__turbopack_context__.v({
  "Holiday": "CardLatest-module-scss-module__eHWZtG__Holiday",
  "cardLatest": "CardLatest-module-scss-module__eHWZtG__cardLatest",
  "cardLinkWrap": "CardLatest-module-scss-module__eHWZtG__cardLinkWrap",
  "eyebrow": "CardLatest-module-scss-module__eHWZtG__eyebrow",
  "headline": "CardLatest-module-scss-module__eHWZtG__headline",
  "image": "CardLatest-module-scss-module__eHWZtG__image",
  "imageContainer": "CardLatest-module-scss-module__eHWZtG__imageContainer",
  "inner": "CardLatest-module-scss-module__eHWZtG__inner",
  "splitHeadline": "CardLatest-module-scss-module__eHWZtG__splitHeadline",
  "withBackground": "CardLatest-module-scss-module__eHWZtG__withBackground",
});
